import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, styled } from '@mui/material';
const InfoIcon = styled(FontAwesomeIcon, {
    shouldForwardProp(propName) {
        return !['error', 'disabled'].includes(propName.toString());
    },
})(({ theme, error, disabled }) => ({
    marginRight: theme.spacing(0.75),
    color: error ? theme.palette.error.main : disabled ? 'inherit' : theme.palette.secondary.main,
    fontSize: 14,
    marginTop: 0,
    position: 'relative',
    top: 1,
    width: 18,
    borderColor: theme.palette.secondary.main,
}));
const InfoLabelWrapper = styled('span', {
    shouldForwardProp(propName) {
        return !['error', 'disabled'].includes(propName.toString());
    },
})(({ theme, error, disabled }) => ({
    color: error ? theme.palette.error.main : 'inherit',
    pointerEvents: disabled ? 'none' : 'auto',
}));
export const PentairInfoLabel = ({ title, description, error, disabled, selectTooltip, }) => {
    if (!description) {
        return (_jsxs(InfoLabelWrapper, { error: Boolean(error), disabled: Boolean(disabled), children: [selectTooltip && (_jsx(Tooltip, { title: description, arrow: true, children: error ? (_jsx(InfoIcon, { icon: faExclamationCircle, error: Boolean(error), disabled: Boolean(disabled) })) : (_jsx(InfoIcon, { icon: faInfoCircle, error: false, disabled: Boolean(disabled) })) })), title] }));
    }
    return (_jsxs(InfoLabelWrapper, { error: Boolean(error), disabled: Boolean(disabled), children: [_jsx(Tooltip, { title: description, arrow: true, children: error ? (_jsx(InfoIcon, { icon: faExclamationCircle, error: Boolean(error), disabled: Boolean(disabled) })) : (_jsx(InfoIcon, { icon: faInfoCircle, error: false, disabled: Boolean(disabled) })) }), title] }));
};
